export default __webpack_public_path__ + "static/media/ocr_upload_error.ccb7191a.svg";